export enum HelpCenterGroup {
  Show,
  ConnectBi,
}
